import React, { useState, useEffect } from "react";
import "../css/Investorgrievance.css";

const DetailsofRegistrar = () => {
  const [DetailsofRegistrar, setDetailsofRegistrar] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetailsofRegistrar = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/DetailsofRegistrar/DetailsofRegistrarDocument`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setDetailsofRegistrar(data.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDetailsofRegistrar();
  }, []);

  return (
    <div className="grievance-container">
      <h1>Details of Registrar</h1>

      {loading && <p>Loading DetailsofRegistrar...</p>}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}

      {!loading && !error && DetailsofRegistrar.length === 0 && (
        <p>No Details of Registrar found.</p>
      )}

      {!loading && !error && DetailsofRegistrar.length > 0 && (
        <div>
          {DetailsofRegistrar.map((grievance) => (
            <div className="grievance-row" key={grievance._id}>
              <div className="grievance-box">
                <h3>Name & Address</h3>
                <p>
                  <strong>Name:</strong> {grievance.name}
                </p>
                <p>
                  <strong>Address:</strong> {grievance.address}
                </p>
              </div>
              <div className="grievance-box">
                <h3>Contact Details</h3>
                <p>
                  <strong>Tel No:</strong> {grievance.telNo}
                </p>
                <p>
                  <strong>Email:</strong> {grievance.emailId}
                </p>
                <p>
                  <strong>Contact Person:</strong> {grievance.contactPerson}
                </p>
                <p>
                  <strong>Website:</strong>{" "}
                  <a
                    href={grievance.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {grievance.website}
                  </a>
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DetailsofRegistrar;
